<div class="thumb" [class.thumb-has-img]="state === 'loaded'">
  <img *ngIf="state === 'loaded'" class="thumb-img" [src]="objectUrl" [alt]="alt" (load)="onImageLoad($event)">
  <div *ngIf="state === 'idle' || state === 'loading'" class="thumb-inner thumb-loading">
    {{ 'SLIDE_DECK_COMPARISON.LOADING_IMAGE' | translate }}
  </div>
  <div *ngIf="state === 'error'" class="thumb-inner thumb-error">
    <i class="fa fa-picture-o" aria-hidden="true"></i>
    <span>{{ 'SLIDE_DECK_COMPARISON.IMAGE_UNAVAILABLE' | translate }}</span>
  </div>
</div>
